import { initializeApp } from 'firebase/app';
import { getFirestore, enableIndexedDbPersistence } from 'firebase/firestore';
import firebaseConfig from './firebaseConfig';

// Initialize Firebase app
const firebaseApp = initializeApp(firebaseConfig);

// Get Firestore instance
const db = getFirestore(firebaseApp);

// Enable Offline Persistence
enableIndexedDbPersistence(db)
    .catch((err) => {
        if (err.code === 'failed-precondition') {
            console.error('Persistence failed: Multiple tabs open.');
        } else if (err.code === 'unimplemented') {
            console.error('Persistence not available in this browser.');
        }
    });

// Export Firestore instance
export default db;